import type { Point } from '@kaiizen/kai-floor-plan';

/** 2D dot product. */
export function dot2d(a: Point, b: Point): number {
  return a.x * b.x + a.y * b.y;
}
